import React, { useState } from "react";
import PropTypes from "prop-types";
//
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";

const RadioSelector = ({ label, option, value, onChange }) => {
  //
  const [inputVal, setInputVal] = useState(value);
  //
  const handleChange = (e, val) => {
    setInputVal(val);
    if (onChange) onChange(val);
  };

  return (
    Array.isArray(option) && (
      <FormControl>
        {label && (
          <FormLabel id="demo-radio-buttons-group-label">{label}</FormLabel>
        )}
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue=""
          name="radio-buttons-group"
          value={inputVal}
          onChange={handleChange}
        >
          {option.map((opt, idx) => (
            <FormControlLabel
              key={idx.toString()}
              value={opt.value}
              disabled={opt.disabled}
              control={<Radio />}
              label={<Typography variant="body2">{opt.label}</Typography>}
            />
          ))}
        </RadioGroup>
      </FormControl>
    )
  );
};

RadioSelector.propTypes = {
  label: PropTypes.node,
  option: PropTypes.arrayOf(PropTypes.any),
  value: PropTypes.string,
  onChange: PropTypes.func,
};

RadioSelector.defaultProps = {
  label: null,
  option: [],
  value: "",
  onChange: () => null,
};

export default RadioSelector;
